import { useState } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../../AlertBox";
import { deleteOdpById } from "../../../api/infrastructure";
import { useOdpByIdHooks } from "../../../utils/infrastructure/OdpUtils";
import { LoadingInsideBox, LoadingInsideBoxWrapper } from "../../Loading";

export default function ModalDeleteOdp({ id, show, onClose, onSuccess }) {
  return (
    <Modal show={show} onHide={() => onClose()}>
      <FormDeleteOdp id={id} onSuccess={onSuccess} onClose={onClose} />
    </Modal>
  );
}

function FormDeleteOdp({ id, onSuccess, onClose }) {
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  let { data, error, loading: loadingData } = useOdpByIdHooks({ id });

  const handleClose = () => {
    if (!loading) {
      setAlert({ show: false, message: "", type: "" });
      onClose();
    }
  };

  const deleteOdp = async () => {
    setLoading(true);
    try {
      let response = await deleteOdpById(id);
      onSuccess(response.data.message);
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    }

    setLoading(false);
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Hapus ODP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoadingInsideBoxWrapper>
          {(loading || loadingData) && <LoadingInsideBox />}
          {error && <div className="alert alert-danger">{error}</div>}
          <AlertBox {...alert} setAlert={setAlert} />
          <h5 className="text-gray-800">
            Apakah anda yakin akan menghapus data ODP "{data.code}"?
          </h5>
        </LoadingInsideBoxWrapper>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={() => handleClose()}>
          Close
        </button>
        <button disabled={loading} className="btn btn-danger" onClick={() => deleteOdp()}>
          <i className="fas fa-trash"></i> {loading ? "Menghapus ODP ..." : "Hapus ODP"}
        </button>
      </Modal.Footer>
    </>
  );
}
